// extracted by mini-css-extract-plugin
module.exports = {"button":"ThemedButton_button__AZCYA","dark":"ThemedButton_dark__3v4_v","light":"ThemedButton_light__u_90L"};